import "./detailed.css";
import { useEffect, useState } from 'react';
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { assetsMap, imageInitializer } from "../../model/assets.js";
import flipIcon from "../../assets/flip.svg";
import infoIcon from "../../assets/info.svg";
import shareIcon from "../../assets/share.svg";
import { FormattedMessage } from "react-intl";

const sharable = navigator.share !== undefined;

const getUrl = (origin, id, display, ctx) => {
    let url = "../";
    let destination;
    if (origin) {
        destination = ["timeline", "photography", "collections", "services"].includes(origin) ? origin : "collections/view";
    } else {
        destination = "gallery";
    }
    const params = [];
    display && params.push(`display=${display}`);
    if (origin && !["timeline", "photography"].includes(origin)) {
        params.push(`id=${origin}`);
        params.push(`origin=${id}`);
    }
    if (ctx) {
        params.push(`ctx=${ctx}`);
    }
    url += destination;
    for (const p in params) {
        if (p === "0") {
            url += `?${params[p]}`
        } else {
            url += `&${params[p]}`
        }
    }
    return url;
}

const DetailedView = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id");
    const [source, setSource] = useState(assetsMap[urlParams.get("id")]);
    const origin = urlParams.get("origin");
    const [showInfo, setShowInfo] = useState(false);
    const [isSideBVisible, setSideBVisibility] = useState(undefined);

    useEffect(() => {
        let timeout = imageInitializer(setSource, source, id);
        const oldColor = document.documentElement.style.getPropertyValue("--b-fullscreen");
        source.colorTheme && document.documentElement.style.setProperty("--b-fullscreen", source.colorTheme);
        document.querySelector("footer").style.display="none";
        return () => {
            clearTimeout(timeout);
            source.colorTheme && document.documentElement.style.setProperty("--b-fullscreen", oldColor);
            document.querySelector("footer").style.display = null;
        }
    }, [source, setSource, id]);

    const getSideB = () => {
        if (assetsMap[source.sideB]) {
            const element = assetsMap[source.sideB];
            return <img draggable="false" className="content" alt={element.name} src={ element.file }/>
        }
        return <p className="align-center sideBText">{ source.sideB }</p>
    };

    const messages = {
        shareTitle: useIntl().messages.shareTitle,
        shareText: useIntl().messages.shareText
    }

    const shareAsset = () => {
        navigator.share && navigator.share({
            title: messages.shareTitleShort,
            url: 'https://saison.one/remyjeuniaux?s=' + urlParams.get("id")
        })
    }

    return (
        source.file && <div className={`view detailed fullscreen align-center ${source.animation || "animateFade"} `}>
            <Link to={getUrl(origin, urlParams.get("id"), urlParams.get("display"), urlParams.get("ctx"))}><button className="reveal reveal-area action top left round align-center"><img draggable="false" alt="" width="35" height="35" src="https://saison.one/assetsCommon/navigation_arrow.svg"/></button></Link>
            <div className={`magicContainer ${isSideBVisible ? "isSideBVisible" : isSideBVisible !== undefined ? "isFlipped" : ""}`}>
                {source.sideB &&
                    <div className="sideBPanel">
                        { getSideB() }
                    </div>
                }
                {
                    source.video && source.video !== "loading"
                    ?
                    <video className="content" src={ source.video } controls={true} autoPlay muted={source.loop} loop={source.loop}/>
                    :
                    <img draggable="false" className="content" alt={source.name} src={ source.file }/>
                }
            </div>
            {source.sideB ?
                <div className="action top right align-center">
                    <button className="reveal reveal-area action round align-center" onClick={() => setSideBVisibility(isSideBVisible !== undefined ? !isSideBVisible : true)}>
                        <img draggable="false" className={`btn-switch ${isSideBVisible ? "active" : isSideBVisible !== undefined ? "inactive" : ""}`} width="35" alt="" src={ flipIcon }/>
                    </button>
                    {
                        sharable &&
                        <button className="reveal reveal-area action round align-center" onClick={shareAsset}>
                            <img draggable="false" width="35" alt="" src={ shareIcon }/>
                        </button>
                    }
                </div>
                :
                sharable &&
                <button className="reveal reveal-area action top right round align-center" onClick={shareAsset}>
                    <img draggable="false" width="35" alt="" src={ shareIcon }/>
                </button>
            }
            {source.description &&
                <>
                    <div className={`info ${showInfo ? "visible" : ""}`}> 
                        <h3 className="info-title">{source.name || "Informations"}</h3>
                        <p>{source.description}</p>
                    </div>
                    <button className="reveal reveal-area action bottom right img align-center" onClick={() => setShowInfo(!showInfo)}>
                        <img draggable="false" className={`btn-info ${showInfo ? "active" : "inactive"}`} width="35" alt="" src={ infoIcon }/>
                        <span>Informations</span>
                    </button>
                </>
            }
            {
                source.coAuthored && <small className="coAuthors action bottom left"><FormattedMessage id="coAuthors" />:<br/><i>{source.coAuthored}</i></small>
            }
        </div>
    );
}

export default DetailedView;